import React from "react";

import { FileText, Package, Truck } from "lucide-react";

import { Button } from "~/components/ui/button";
import { SalesRequest } from "~/types/client";

interface PendingActionsProps {
  order: SalesRequest;
  onCreateDispatchGuide: (order: SalesRequest) => void;
  isCreatingDispatchGuide: string | null;
}

interface AcceptedActionsProps {
  order: SalesRequest;
  isLoadingTransition: string | null;
  onInTransit: (order: SalesRequest) => void;
  onCreateDispatchGuide: (order: SalesRequest) => void;
  isCreatingDispatchGuide: string | null;
}

interface TransitActionsProps {
  order: SalesRequest;
  isLoadingTransition: string | null;
  onDelivery: (order: SalesRequest) => void;
}

interface FacturadoActionsProps {
  order: SalesRequest;
  isLoadingTransition: string | null;
  onMarkDelivered: (order: SalesRequest) => void;
}

interface PorFacturarActionsProps {
  order: SalesRequest;
  onCreateDispatchGuide: (order: SalesRequest) => void;
  isCreatingDispatchGuide: string | null;
}

export const PendingActions: React.FC<PendingActionsProps> = ({
  order,
  onCreateDispatchGuide,
  isCreatingDispatchGuide,
}) => (
  <div className="flex gap-2">
    <Button
      size="sm"
      onClick={() => onCreateDispatchGuide(order)}
      disabled={isCreatingDispatchGuide === order.id}
      className="bg-green-500 text-white hover:bg-green-700"
    >
      {isCreatingDispatchGuide === order.id ? "Creando..." : "Crear Guía"}
      <FileText className="ml-2 h-4 w-4" />
    </Button>
  </div>
);

export const AcceptedActions: React.FC<AcceptedActionsProps> = ({
  order,
  isLoadingTransition,
  onInTransit,
  onCreateDispatchGuide,
  isCreatingDispatchGuide,
}) => (
  <div className="flex gap-2">
    <Button
      size="sm"
      onClick={() => onCreateDispatchGuide(order)}
      disabled={
        isCreatingDispatchGuide === order.id || isLoadingTransition === order.id
      }
      className="bg-green-500 text-white hover:bg-green-700"
    >
      {isCreatingDispatchGuide === order.id ? "Creando..." : "Crear Guía"}
      <FileText className="ml-2 h-4 w-4" />
    </Button>
    <Button
      size="sm"
      onClick={() => onInTransit(order)}
      disabled={
        isLoadingTransition === order.id || isCreatingDispatchGuide === order.id
      }
      className="bg-blue-500 text-white hover:bg-blue-700"
    >
      {isLoadingTransition === order.id ? "Marcando..." : "En tránsito"}
      <Truck className="ml-2 h-4 w-4" />
    </Button>
  </div>
);

export const TransitActions: React.FC<TransitActionsProps> = ({
  order,
  isLoadingTransition,
  onDelivery,
}) => (
  <div className="flex gap-2">
    <Button
      size="sm"
      onClick={() => onDelivery(order)}
      disabled={isLoadingTransition === order.id}
      className="bg-purple-500 text-white hover:bg-purple-700"
    >
      {isLoadingTransition === order.id ? "Marcando..." : "Registrar entrega"}
      <Package className="ml-2 h-4 w-4" />
    </Button>
  </div>
);

export const FacturadoActions: React.FC<FacturadoActionsProps> = ({
  order,
  isLoadingTransition,
  onMarkDelivered,
}) => (
  <div className="flex gap-2">
    <Button
      size="sm"
      onClick={() => onMarkDelivered(order)}
      disabled={isLoadingTransition === order.id}
      className="bg-purple-500 text-white hover:bg-purple-700"
    >
      {isLoadingTransition === order.id ? "Marcando..." : "Marcar entregado"}
      <Package className="ml-2 h-4 w-4" />
    </Button>
  </div>
);

export const DeliveredActions = () => (
  <span className="text-muted-foreground">Sin acciones</span>
);

export const PorFacturarActions: React.FC<PorFacturarActionsProps> = ({
  order,
  onCreateDispatchGuide,
  isCreatingDispatchGuide,
}) => (
  <div className="flex gap-2">
    <Button
      size="sm"
      onClick={() => onCreateDispatchGuide(order)}
      disabled={isCreatingDispatchGuide === order.id}
      className="bg-orange-500 text-white hover:bg-orange-700"
    >
      {isCreatingDispatchGuide === order.id ? "Creando..." : "Crear Guía"}
      <FileText className="ml-2 h-4 w-4" />
    </Button>
  </div>
);
